import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  Plugins,
  withSystem,
  withMeta,
  type Type,
  Component,
  Variable,
  Expressions,
  ElementPreset,
} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  typeName,
  identifier,
} from '@packages/systems/wfdl-Qualified';
import {createIntegratedComponent} from '@packages/utilities/platform';

import {
  TBoolean,
  TNumber,
  TText,
  TList,
  TRecord,
  TUnion,
  TEnum,
  EElement,
  EText,
  ERecord,
  ESelect,
  EBoolean,
  ENumber,
  EEnum,
  ELiteral,
  ECase,
  EUnion,
  EList,
  EVariable,
  ECall,
  EFunction,
  EData,
  EExtend,
  TGeneric,
  TElement,
  TTypeReference,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';

const {Plugin} = Plugins;

const privilegedLabPlugin = Plugins.name('PrivilegedLab');
const labIcon = iconName('LabPreset');
const labElementIcon = iconName('LabElement');

const heroType: Type = withMeta(
  {
    renderSummaryKeys: [
      {
        key: 'alias',
        addons: {
          prefix: '',
          postfix: ':',
        },
      },
      {
        key: 'age',
        addons: {
          prefix: ' ',
          postfix: '',
        },
      },
    ],
  },
  withSystem(
    {label: 'Superhero'},
    TRecord({
      alias: withMeta(
        {
          placeholder: 'Who is under the mask?',
        },
        withSystem(
          {
            label: 'Alias',
            defaultValue: 'Bruce Wayne',
            isBindable: true,
          },
          TText
        )
      ),
      age: withSystem(
        {
          label: 'Age',
          defaultValue: 33,
          isBindable: true,
          hintText: 'This is a hint that should not be visible',
          toolTipText: 'This tooltip should not be visible',
        },
        withMeta(
          {
            value: {
              min: 0,
              max: 150,
              step: 1,
            },
          },
          TNumber
        )
      ),
    })
  )
);

export const plugin = Plugin({
  components: {
    KitchenSinkComponent: createIntegratedComponent({
      icon: qualify(
        Plugins.name('PrivilegedLab'),
        iconName('KitchenSinkElement')
      ),
      displayName: 'Kitchen Sink Component',
      render: {
        id: 'KitchenSinkComponent',
        type: qualify(Plugins.name('Builtin'), Component.name('DOM')),
        data: {
          tag: EEnum('div'),
          attributes: EList([
            ERecord({
              name: EText('style'),
              value: ECall({
                fun: Expressions.qualifiedVariable('PrivilegedLab', 'toStyle'),
                arg: EData(['styles']),
              }),
            }),
            ERecord({
              name: EText('id'),
              value: EData(['attr', 'id']),
            }),
          ]),
          children: ECall({
            fun: ECall({
              fun: Expressions.qualifiedVariable('PrivilegedLab', 'concat'),
              arg: EList([
                EElement({
                  id: '2',
                  type: qualify(Plugins.name('Builtin'), Component.name('DOM')),
                  data: ERecord({
                    tag: EText('ul'),
                    children: EList([
                      EElement({
                        id: '3',
                        type: qualify(
                          Plugins.name('Builtin'),
                          Component.name('DOM')
                        ),
                        data: ERecord({
                          tag: EText('li'),
                          children: EList([
                            EElement({
                              id: '4',
                              type: qualify(
                                Plugins.name('Basic'),
                                Component.name('String')
                              ),
                              data: EText('isCool: '),
                            }),
                            ECase({
                              value: ECall({
                                fun: Expressions.qualifiedVariable(
                                  'PrivilegedLab',
                                  'booleanToUnion'
                                ),
                                arg: EData(['isCool']),
                              }),
                              cases: {
                                true: EFunction({
                                  param: '_',
                                  body: EElement({
                                    id: '5',
                                    type: qualify(
                                      Plugins.name('Basic'),
                                      Component.name('String')
                                    ),
                                    data: EText('yes'),
                                  }),
                                }),
                                false: EFunction({
                                  param: '_',
                                  body: EElement({
                                    id: '6',
                                    type: qualify(
                                      Plugins.name('Basic'),
                                      Component.name('String')
                                    ),
                                    data: EText('no'),
                                  }),
                                }),
                              },
                            }),
                          ]),
                        }),
                      }),
                      EElement({
                        id: '7',
                        type: qualify(
                          Plugins.name('Builtin'),
                          Component.name('DOM')
                        ),
                        data: ERecord({
                          tag: EText('li'),
                          children: EList([
                            EElement({
                              id: '8',
                              type: qualify(
                                Plugins.name('Basic'),
                                Component.name('String')
                              ),
                              data: EText('bestSeason: '),
                            }),
                            EElement({
                              id: '9',
                              type: qualify(
                                Plugins.name('Basic'),
                                Component.name('String')
                              ),
                              data: ECall({
                                fun: Expressions.qualifiedVariable(
                                  'PrivilegedLab',
                                  'enumToText'
                                ),

                                arg: EData(['bestSeason']),
                              }),
                            }),
                          ]),
                        }),
                      }),
                      EElement({
                        id: '10',
                        type: qualify(
                          Plugins.name('Builtin'),
                          Component.name('DOM')
                        ),
                        data: ERecord({
                          tag: EText('li'),
                          children: EList([
                            EElement({
                              id: '11',
                              type: qualify(
                                Plugins.name('Basic'),
                                Component.name('String')
                              ),
                              data: EText('Superhero: '),
                            }),
                            EElement({
                              id: '12',
                              type: qualify(
                                Plugins.name('Builtin'),
                                Component.name('DOM')
                              ),
                              data: ERecord({
                                tag: EText('ul'),
                                children: EList([
                                  EElement({
                                    id: '13',
                                    type: qualify(
                                      Plugins.name('Builtin'),
                                      Component.name('DOM')
                                    ),
                                    data: ERecord({
                                      tag: EText('li'),
                                      children: EList([
                                        EElement({
                                          id: '14',
                                          type: qualify(
                                            Plugins.name('Basic'),
                                            Component.name('String')
                                          ),
                                          data: EText('Alias: '),
                                        }),
                                        EElement({
                                          id: '15',
                                          type: qualify(
                                            Plugins.name('Basic'),
                                            Component.name('String')
                                          ),
                                          data: EData(['person', 'alias']),
                                        }),
                                      ]),
                                    }),
                                  }),
                                  EElement({
                                    id: '16',
                                    type: qualify(
                                      Plugins.name('Builtin'),
                                      Component.name('DOM')
                                    ),
                                    data: ERecord({
                                      tag: EText('li'),
                                      children: EList([
                                        EElement({
                                          id: '17',
                                          type: qualify(
                                            Plugins.name('Basic'),
                                            Component.name('String')
                                          ),
                                          data: EText('Age: '),
                                        }),
                                        EElement({
                                          id: '18',
                                          type: qualify(
                                            Plugins.name('Basic'),
                                            Component.name('String')
                                          ),
                                          data: ECall({
                                            fun: Expressions.qualifiedVariable(
                                              'PrivilegedLab',
                                              'numberToText'
                                            ),
                                            arg: EData(['person', 'age']),
                                          }),
                                        }),
                                      ]),
                                    }),
                                  }),
                                ]),
                              }),
                            }),
                          ]),
                        }),
                      }),
                      EElement({
                        id: '19',
                        type: qualify(
                          Plugins.name('Builtin'),
                          Component.name('DOM')
                        ),
                        data: ERecord({
                          tag: EText('li'),
                          children: EList([
                            EElement({
                              id: '20',
                              type: qualify(
                                Plugins.name('Basic'),
                                Component.name('String')
                              ),
                              data: EText('Contact: '),
                            }),
                            EElement({
                              id: '21',
                              type: qualify(
                                Plugins.name('Builtin'),
                                Component.name('DOM')
                              ),
                              data: ERecord({
                                tag: EText('ul'),
                                children: EList([
                                  EElement({
                                    id: '22',
                                    type: qualify(
                                      Plugins.name('Builtin'),
                                      Component.name('DOM')
                                    ),
                                    data: ERecord({
                                      tag: EText('li'),
                                      children: EList([
                                        EElement({
                                          id: '23',
                                          type: qualify(
                                            Plugins.name('Basic'),
                                            Component.name('String')
                                          ),
                                          data: ECase({
                                            value: EData(['contact']),
                                            cases: {
                                              Mail: EFunction({
                                                param: '_',
                                                body: EText('Mail'),
                                              }),
                                              Phone: EFunction({
                                                param: '_',
                                                body: EText('Phone'),
                                              }),
                                            },
                                          }),
                                        }),
                                        EElement({
                                          id: '24',
                                          type: qualify(
                                            Plugins.name('Basic'),
                                            Component.name('String')
                                          ),
                                          data: EText(': '),
                                        }),
                                        EElement({
                                          id: '25',
                                          type: qualify(
                                            Plugins.name('Basic'),
                                            Component.name('String')
                                          ),
                                          data: ECase({
                                            value: EData(['contact']),
                                            cases: {
                                              Mail: EFunction({
                                                param: 'address',
                                                body: EVariable(
                                                  Variable.unqualified(
                                                    identifier('address')
                                                  )
                                                ),
                                              }),
                                              Phone: EFunction({
                                                param: 'phone',
                                                body: EVariable(
                                                  Variable.unqualified(
                                                    identifier('phone')
                                                  )
                                                ),
                                              }),
                                            },
                                          }),
                                        }),
                                      ]),
                                    }),
                                  }),
                                ]),
                              }),
                            }),
                          ]),
                        }),
                      }),
                      EElement({
                        id: '26',
                        type: qualify(
                          Plugins.name('Builtin'),
                          Component.name('DOM')
                        ),
                        data: ERecord({
                          tag: EText('li'),
                          children: EList([
                            EElement({
                              id: '27',
                              type: qualify(
                                Plugins.name('Basic'),
                                Component.name('String')
                              ),
                              data: EText('List of anything has length: '),
                            }),
                            EElement({
                              id: '28',
                              type: qualify(
                                Plugins.name('Builtin'),
                                Component.name('DOM')
                              ),
                              data: ERecord({
                                tag: EText('strong'),
                                children: EList([
                                  EElement({
                                    id: '29',
                                    type: qualify(
                                      Plugins.name('Basic'),
                                      Component.name('String')
                                    ),
                                    data: ECall({
                                      fun: Expressions.qualifiedVariable(
                                        'PrivilegedLab',
                                        'numberToText'
                                      ),
                                      arg: ECall({
                                        fun: Expressions.qualifiedVariable(
                                          'PrivilegedLab',
                                          'length'
                                        ),
                                        arg: EData(['anyList']),
                                      }),
                                    }),
                                  }),
                                ]),
                              }),
                            }),
                          ]),
                        }),
                      }),
                    ]),
                  }),
                }),
                EElement({
                  id: '30',
                  type: qualify(Plugins.name('Builtin'), Component.name('DOM')),
                  data: ERecord({
                    tag: EEnum('div'),
                    attributes: EList([
                      ERecord({
                        name: EText('style'),
                        value: ERecord({
                          border: EText('4px solid white'),
                          padding: ENumber(8),
                        }),
                      }),
                    ]),
                    children: ECall({
                      fun: ECall({
                        fun: Expressions.qualifiedVariable(
                          'PrivilegedLab',
                          'map'
                        ),

                        arg: EFunction({
                          param: 'item',
                          body: EElement({
                            id: '31',
                            type: qualify(
                              Plugins.name('Builtin'),
                              Component.name('DOM')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              children: EList([
                                EElement({
                                  id: '32',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: ESelect({
                                    from: ESelect({
                                      from: EVariable(
                                        Variable.unqualified(identifier('item'))
                                      ),
                                      prop: 'item',
                                    }),
                                    prop: 'alias',
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        }),
                      }),
                      arg: EData(['candidates']),
                    }),
                  }),
                }),
                // Extend the Record `fontStyle` to be italic
                EElement({
                  id: '33',
                  type: qualify(Plugins.name('Builtin'), Component.name('DOM')),
                  data: ERecord({
                    tag: EEnum('div'),
                    attributes: EList([
                      ERecord({
                        name: EText('style'),
                        value: EExtend({
                          record: ERecord({
                            fontStyle: Expressions.qualifiedVariable(
                              'PrivilegedLab',
                              'bold'
                            ),

                            padding: ENumber(8),
                          }),
                          prop: 'fontStyle',
                          value: Expressions.qualifiedVariable(
                            'PrivilegedLab',
                            'italic'
                          ),
                        }),
                      }),
                    ]),
                    children: EList([
                      EElement({
                        id: '34',
                        type: qualify(
                          Plugins.name('Basic'),
                          Component.name('String')
                        ),
                        data: EText('Extend Type `italic` example'),
                      }),
                    ]),
                  }),
                }),
                EElement({
                  id: '35',
                  type: qualify(
                    Plugins.name('Basic'),
                    Component.name('String')
                  ),
                  data: EData(['manylines']),
                }),
              ]),
            }),
            arg: EData(['children']),
          }),
        },
      },
      fields: {
        isCool: {
          dataType: withSystem(
            {
              label: 'Is Cool',
              defaultValue: false,
              isBindable: true,
            },
            TBoolean
          ),
          defaultValue: EBoolean(false),
        },
        bestSeason: {
          dataType: withSystem(
            {
              defaultValue: 'Spring',
              isBindable: true,
              label: 'Best Season',
            },
            withMeta(
              {variant: 'menu'},
              TEnum({
                Winter: 'Winter',
                Spring: 'Spring',
                Summer: 'Summer',
                Fall: 'Fall',
              })
            )
          ),
          defaultValue: EEnum('Spring'),
        },
        person: {
          dataType: heroType,
          defaultValue: ERecord({
            alias: EText('Bruce Wayne'),
            age: ENumber(33),
          }),
        },
        contact: {
          dataType: withSystem(
            {
              label: 'Contact',
              defaultValue: {tag: 'Phone', val: '801-243-6679'},
              isBindable: true,
            },
            TUnion({
              Mail: withMeta(
                {
                  placeholder: '123 High Lane, Towsville',
                },
                withSystem(
                  {
                    label: 'Address',
                    defaultValue: '1007 Mountain Drive, Gotham',
                    isBindable: true,
                  },
                  TText
                )
              ),

              Phone: withMeta(
                {
                  placeholder: '(555) 555 5555',
                },
                withSystem(
                  {
                    label: 'Number',
                    defaultValue: '(111) 111 1111',
                    isBindable: true,
                  },
                  TText
                )
              ),
            })
          ),
          defaultValue: EUnion({
            tag: 'Phone',
            value: EText('801-243-6679'),
          }),
        },
        anyList: {
          dataType: withSystem(
            {
              label: 'A List',
              isBindable: true,
            },
            TGeneric({
              arg: 'ListItem',
              body: withSystem(
                {isBindable: true},
                TList(
                  withSystem({isBindable: true}, TTypeReference('ListItem'))
                )
              ),
            })
          ),
          defaultValue: EList([]),
        },
        candidates: {
          dataType: withSystem(
            {
              label: 'Candidates',
              defaultValue: [],
              isBindable: true,
              hintText: 'This is a hint',
            },
            TList(heroType)
          ),
          defaultValue: EList([]),
        },
        styles: {
          dataType: withSystem(
            {
              label: 'Styles',
              isBindable: true,
              toolTipText: 'This is a tooltip!',
              defaultValue: [
                {styleProperty: 'backgroundColor', value: 'red'},
                {styleProperty: 'padding', value: '20px'},
                {styleProperty: 'color', value: 'white'},
                {styleProperty: 'fontSize', value: '32px'},
                {styleProperty: 'lineHeight', value: '1.2'},
              ],
            },
            withMeta(
              {
                sortable: true,
              },
              TList(
                withMeta(
                  {
                    renderSummaryKeys: [
                      {
                        key: 'styleProperty',
                        addons: {
                          prefix: '',
                          postfix: '=',
                        },
                      },
                      {
                        key: 'value',
                        addons: {
                          prefix: '"',
                          postfix: '"',
                        },
                      },
                    ],
                  },
                  TRecord({
                    styleProperty: withSystem(
                      {
                        label: 'Property',
                      },
                      TText
                    ),
                    value: withSystem(
                      {
                        label: 'Value',
                      },
                      TText
                    ),
                  })
                )
              )
            )
          ),
          defaultValue: EList([
            ERecord({
              styleProperty: EText('backgroundColor'),
              value: EText('red'),
            }),
            ERecord({
              styleProperty: EText('padding'),
              value: EText('20px'),
            }),
            ERecord({
              styleProperty: EText('color'),
              value: EText('white'),
            }),
            ERecord({
              styleProperty: EText('fontSize'),
              value: EText('32px'),
            }),
            ERecord({
              styleProperty: EText('lineHeight'),
              value: EText('1.2'),
            }),
          ]),
        },
        children: {
          dataType: withSystem(
            {label: 'Children', defaultValue: [], isBindable: true},
            TList(withMeta({multiLine: true}, TElement))
          ),
          defaultValue: EList([]),
        },
        favoriteColor: {
          dataType: withSystem(
            {label: 'My color'},
            TTypeConstructor(qualify(privilegedLabPlugin, typeName('Color')))
          ),
          defaultValue: ERecord({
            r: ENumber(0),
            g: ENumber(0),
            b: ENumber(0),
          }),
        },
        manylines: {
          dataType: withSystem(
            {label: 'Many lines'},
            TTypeConstructor(
              qualify(Plugins.name('Basic'), typeName('MultilineText'))
            )
          ),
          defaultValue: EText(''),
        },
      },
    }),
    SimplePluginComponent: Component.create({
      displayName: 'Simple Plugin Component',
      icon: qualify(privilegedLabPlugin, labElementIcon),
      dataType: TRecord({}),
      defaultData: EFunction({
        param: identifier('context'),
        body: ERecord({}),
      }),
      render: EElement({
        id: 'SimplePluginComponent',
        type: qualify(Plugins.name('Builtin'), Component.name('DOM')),
        data: ERecord({
          tag: EEnum('div'),
          attributes: EList([
            ERecord({
              name: EText('data-name'),
              value: EText('DOM Element'),
            }),
          ]),
          children: EList([
            EElement({
              id: 'content',
              type: qualify(Plugins.name('Builtin'), Component.name('DOM')),
              data: ERecord({
                tag: EText('h3'),
                children: EList([
                  EElement({
                    id: 'text',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('String')
                    ),
                    data: EText('I am a simple plugin component'),
                  }),
                ]),
              }),
            }),
          ]),
        }),
      }),
    }),
    DevelopmentPluginComponent: Component.create({
      icon: qualify(privilegedLabPlugin, labElementIcon),
      render: EElement({
        id: '1',
        type: qualify(Plugins.name('Builtin'), Component.name('DOM')),
        data: ERecord({
          tag: EEnum('div'),
          children: EData(['children']),
          attributes: EList([
            ERecord({
              name: EText('data-name'),
              value: EText('DOM Element'),
            }),
          ]),
        }),
      }),
      constraints: {
        ancestors: [{is: 'Block', rule: 'AtLeastOne'}],
      },
      displayName: 'Plugin Component',
      dataType: TRecord({
        children: withSystem(
          {label: 'Text', isBindable: true},
          TList(withMeta({multiLine: true}, TElement))
        ),
      }),
      defaultData: EFunction({
        param: identifier('context'),
        body: ERecord({
          children: EList([]),
        }),
      }),
      style: {
        base: {
          main: {
            noPseudo: {
              display: 'grid',
              alignItems: 'center',
              justifyItems: 'center',
              color: {r: 204, g: 204, b: 204, a: 1},
              backgroundColor: {r: 161, g: 161, b: 161, a: 1},
              paddingTop: px(16),
              paddingBottom: px(16),
            },
          },
        },
      },
    }),
    DevelopmentPluginComponentWithNesting: Component.create({
      icon: qualify(privilegedLabPlugin, labElementIcon),
      render: EElement({
        id: 'DevelopmentPluginComponentWithNesting',
        type: qualify(Plugins.name('Basic'), Component.name('Block')),
        data: ERecord({
          tag: EEnum('div'),
          style: ERecord({
            base: ERecord({
              main: ERecord({
                noPseudo: ERecord({
                  display: EText('grid'),
                  alignItems: EText('center'),
                  justifyItems: EText('center'),
                  gridTemplateColumns: EText('1fr 1fr 1fr'),
                  gridGap: EText('16px'),
                  paddingLeft: EText('16px'),
                  paddingRight: EText('16px'),
                  paddingTop: EText('16px'),
                  paddingBottom: EText('16px'),
                }),
              }),
            }),
          }),
          children: EList([
            EElement({
              id: 'nested-DevelopmentPluginComponent-1',
              type: qualify(
                Plugins.name('Lab'),
                Component.name('DevelopmentPluginComponent')
              ),
              data: ERecord({
                children: EData(['NestedChildren1']),
              }),
            }),
            EElement({
              id: 'nested-DevelopmentPluginComponent-2',
              type: qualify(
                Plugins.name('Lab'),
                Component.name('DevelopmentPluginComponent')
              ),
              data: ERecord({
                children: EData(['NestedChildren2']),
              }),
            }),
            EElement({
              id: 'inner-wrapper',
              type: qualify(Plugins.name('Basic'), Component.name('Block')),
              data: ERecord({
                tag: EEnum('div'),
                style: ERecord({
                  base: ERecord({
                    main: ERecord({
                      noPseudo: ERecord({
                        backgroundColor: EText('red'),
                        paddingLeft: EText('16px'),
                        paddingRight: EText('16px'),
                        paddingTop: EText('16px'),
                        paddingBottom: EText('16px'),
                      }),
                    }),
                  }),
                }),
                children: EList([
                  EElement({
                    id: 'deeply-nested-DevelopmentPluginComponent-3',
                    type: qualify(
                      Plugins.name('Lab'),
                      Component.name('DevelopmentPluginComponent')
                    ),
                    data: ERecord({
                      children: EData(['NestedChildren3']),
                    }),
                  }),
                ]),
              }),
            }),
          ]),
        }),
      }),
      displayName: 'Nested Plugin Component',
      dataType: TRecord({
        NestedChildren1: withSystem(
          {label: 'Nested Text 1', isBindable: true},
          TList(withMeta({multiLine: true}, TElement))
        ),
        NestedChildren2: withSystem(
          {label: 'Nested Text 2', isBindable: true},
          TList(withMeta({multiLine: true}, TElement))
        ),
        NestedChildren3: withSystem(
          {label: 'Nested Text 3', isBindable: true},
          TList(withMeta({multiLine: true}, TElement))
        ),
      }),
      defaultData: EFunction({
        param: identifier('context'),
        body: ERecord({
          NestedChildren1: EList([]),
          NestedChildren2: EList([]),
          NestedChildren3: EList([]),
        }),
      }),
      style: {
        base: {
          main: {
            noPseudo: {
              display: 'grid',
              alignItems: 'center',
              justifyItems: 'center',
              color: {r: 204, g: 204, b: 204, a: 1},
              backgroundColor: {r: 161, g: 161, b: 161, a: 1},
              paddingTop: px(16),
              paddingBottom: px(16),
            },
          },
        },
      },
    }),
  },
  elementPresets: {
    KitchenSinkComponentInstanceFactory: ElementPreset.createSafe({
      factory: EElement({
        id: 'KitchenSinkComponentInstance',
        type: qualify(
          Plugins.name('Lab'),
          Component.name('KitchenSinkComponent')
        ),
        data: ERecord({
          attr: ERecord({id: EText('test-id')}),
          xattr: EList([
            ERecord({
              name: EText('data-test'),
              value: EText('testing'),
            }),
          ]),
          children: EList([]),
          styleBlockIds: EList([]),
          isCool: EBoolean(false),
          bestSeason: EEnum('Spring'),
          person: ERecord({
            alias: EText('Super Man'),
            age: ENumber(99),
          }),
          contact: EUnion({
            tag: 'Mail',
            value: EText('1007 Mountain Drive, Gotham'),
          }),
          anyList: EList([]),
          candidates: EList([]),
          styles: EList([
            ERecord({
              styleProperty: EText('backgroundColor'),
              value: EText('red'),
            }),
            ERecord({
              styleProperty: EText('padding'),
              value: EText('20px'),
            }),
            ERecord({
              styleProperty: EText('color'),
              value: EText('white'),
            }),
            ERecord({
              styleProperty: EText('fontSize'),
              value: EText('32px'),
            }),
            ERecord({
              styleProperty: EText('lineHeight'),
              value: EText('1.2'),
            }),
          ]),
          favoriteColor: ERecord({
            r: ENumber(10),
            g: ENumber(10),
            b: ENumber(10),
          }),
          manylines: EText('this is a text area maybe'),
        }),
      }),
      label: 'Kitchen Sink Component',
      icon: {
        medium: qualify(privilegedLabPlugin, labIcon),
        small: qualify(privilegedLabPlugin, labIcon),
      },
      helpData: {
        description: [
          "The Kitchen Sink Component is the Core team's Lab component of a 3rd party plugin. The implementation is built entirely with WFDL and would be safe to expose to third parties.",
          'When all behaviors of this component are working properly, we will have completed the Plugin Component MVP',
        ],
        tip: 'The Kitchen Sink Component is the Plugin Component version of the Kitchen Sink Atom',
        link: {
          text: 'Learn more about Reusable Element Primitives',
          href: 'https://paper.dropbox.com/doc/Reusable-Element-Primitives--BDuqVzhWpGxWlw7dU6BA4zhvAg-dZKRCSjAOBf6G8TZJ3uQM',
        },
      },
    }),
    SimplePluginComponentInstanceFactory: ElementPreset.createSafe({
      factory: EElement({
        id: 'SimplePluginComponentInstance',
        type: qualify(
          Plugins.name('Lab'),
          Component.name('SimplePluginComponent')
        ),
        data: ERecord({}),
      }),
      label: 'Simple Plugin Component',
      icon: {
        medium: qualify(privilegedLabPlugin, labIcon),
        small: qualify(privilegedLabPlugin, labIcon),
      },
      helpData: {
        description: [
          'The "Plugin Component" Component is a simple Plugin Component for the purposes of testing the Plugin Component effort progress',
        ],
        link: {
          text: 'Learn more about Reusable Element Primitives',
          href: 'https://paper.dropbox.com/doc/Reusable-Element-Primitives--BDuqVzhWpGxWlw7dU6BA4zhvAg-dZKRCSjAOBf6G8TZJ3uQM',
        },
      },
    }),
    DevelopmentPluginComponentInstanceFactory: ElementPreset.createSafe({
      factory: EElement({
        id: 'DevelopmentPluginComponentInstance',
        type: qualify(
          Plugins.name('Lab'),
          Component.name('DevelopmentPluginComponent')
        ),
        data: ERecord({
          children: EList([
            EElement({
              id: '2',
              type: qualify(Plugins.name('Basic'), Component.name('String')),
              data: EText('Plugin Component'),
            }),
          ]),
        }),
      }),
      label: 'Plugin Component',
      icon: {
        medium: qualify(privilegedLabPlugin, labIcon),
        small: qualify(privilegedLabPlugin, labIcon),
      },
      helpData: {
        description: [
          'The "Plugin Component" Component is a simple Plugin Component for the purposes of testing the Plugin Component effort progress',
        ],
        link: {
          text: 'Learn more about Reusable Element Primitives',
          href: 'https://paper.dropbox.com/doc/Reusable-Element-Primitives--BDuqVzhWpGxWlw7dU6BA4zhvAg-dZKRCSjAOBf6G8TZJ3uQM',
        },
      },
    }),
    DevelopmentPluginComponentWithNestingInstanceFactory:
      ElementPreset.createSafe({
        factory: EElement({
          id: 'DevelopmentPluginComponentWithNestingInstance',
          type: qualify(
            Plugins.name('Lab'),
            Component.name('DevelopmentPluginComponentWithNesting')
          ),
          data: ERecord({
            NestedChildren1: EList([
              EElement({
                id: '1',
                type: qualify(Plugins.name('Basic'), Component.name('String')),
                data: EText('Plugin Component 1'),
              }),
            ]),
            NestedChildren2: EList([
              EElement({
                id: '2',
                type: qualify(Plugins.name('Basic'), Component.name('String')),
                data: EText('Plugin Component 2'),
              }),
            ]),
            NestedChildren3: EList([
              EElement({
                id: '3',
                type: qualify(Plugins.name('Basic'), Component.name('String')),
                data: EText('Plugin Component 3'),
              }),
            ]),
          }),
        }),
        label: 'Nested Plugin Component',
        icon: {
          medium: qualify(privilegedLabPlugin, labIcon),
          small: qualify(privilegedLabPlugin, labIcon),
        },
        helpData: {
          description: [
            'The "Nested Plugin Component" Component is a more complex Plugin Component with nested components for the purposes of testing the Plugin Component effort progress',
          ],
          link: {
            text: 'Learn more about Reusable Element Primitives',
            href: 'https://paper.dropbox.com/doc/Reusable-Element-Primitives--BDuqVzhWpGxWlw7dU6BA4zhvAg-dZKRCSjAOBf6G8TZJ3uQM',
          },
        },
      }),
    IX2InstanceFactoryOnClass: ElementPreset.createSafe({
      factory: EElement({
        id: '46dcb934-1dd9-5879-4ae0-854b5dd7f385',
        type: qualify(Plugins.name('Basic'), Component.name('Block')),
        data: ERecord({
          tag: EEnum('div'),
          text: EBoolean(false),
          styleBlockIds: EList([EText('556cc23b-be38-0633-2ca2-8d9dcfe6352c')]),
          children: EList([
            EElement({
              id: '063e8706-c22e-11bc-0292-28ff8d90ec28',
              type: qualify(Plugins.name('Basic'), Component.name('Image')),
              data: ERecord({
                attr: ERecord({
                  src: EText(
                    'https://dev-assets.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg'
                  ),
                  loading: EEnum('lazy'),
                  width: EText('auto'),
                  height: EText('auto'),
                  alt: EText('__wf_reserved_inherit'),
                }),
                img: ELiteral({
                  name: qualify(Plugins.name('Asset'), typeName('Image')),
                  value: JSON.parse(
                    '{"id":"plugins/Basic/assets/placeholder.svg"}'
                  ),
                }),
                styleBlockIds: EList([EText('testingix2class')]),
                temp: ERecord({
                  img: ERecord({
                    src: EText(''),
                  }),
                }),
                srcsetDisabled: EBoolean(false),
                sizes: EList([]),
              }),
            }),
            EElement({
              id: '809d0967-6933-7048-d878-5060b53c0073',
              type: qualify(Plugins.name('Basic'), Component.name('Heading')),
              data: ERecord({
                tag: EEnum('h1'),
                children: EList([
                  EElement({
                    id: 'deb0fe7c-1c15-45fe-55ca-6ba9249e8347',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('String')
                    ),
                    data: EText('Ix2 for element presets!'),
                  }),
                ]),
                styleBlockIds: EList([EText('testingix2class')]),
              }),
            }),
          ]),
        }),
      }),
      styleBlocks: [
        {
          _id: 'testingix2class',
          fake: false,
          type: 'class',
          name: 'bicycle',
          namespace: '',
          comb: '',
          styleLess: '',
          variants: {},
          children: [],
          createdBy: null,
        },
      ],
      interactions: {
        actionLists: [],
        events: [
          {
            id: 'e',
            name: '',
            animationType: 'preset',
            eventTypeId: 'MOUSE_CLICK',
            action: null,
            mediaQueries: ['main', 'medium', 'small', 'tiny'],
            target: {
              appliesTo: 'CLASS',
              styleBlockIds: ['testingix2class'],
              id: '63075a96ff5d78202eea0624|809d0967-6933-7048-d878-5060b53c0073',
            },
            targets: [],
            config: {
              loop: false,
              playInReverse: false,
              scrollOffsetValue: null,
              scrollOffsetUnit: null,
              delay: null,
              direction: null,
              effectIn: null,
            },
            createdOn: 1661609055738,
          },
          {
            id: 'e-2',
            name: '',
            animationType: 'preset',
            eventTypeId: 'MOUSE_SECOND_CLICK',
            action: {
              id: '',
              actionTypeId: 'JIGGLE_EFFECT',
              // @ts-expect-error - missing properties
              config: {
                actionListId: 'JIGGLE_EFFECT',
                autoStopEventId: 'e',
              },
              instant: false,
            },
            mediaQueries: ['main', 'medium', 'small', 'tiny'],
            target: {
              appliesTo: 'CLASS',
              styleBlockIds: ['testingix2class'],
              id: '63075a96ff5d78202eea0624|809d0967-6933-7048-d878-5060b53c0073',
            },
            targets: [],
            config: {
              loop: false,
              playInReverse: false,
              scrollOffsetValue: null,
              scrollOffsetUnit: null,
              delay: 0,
              direction: null,
              effectIn: null,
            },
            createdOn: 1661609055739,
          },
        ],

        interactions: [
          {
            id: 'i',
            interactionTypeId: 'MOUSE_CLICK_INTERACTION',
            eventIds: ['e', 'e-2'],
            target:
              '63075a96ff5d78202eea0624|809d0967-6933-7048-d878-5060b53c0073',
            createdOn: 1661609055738,
          },
        ],
      },
      label: 'class IX2',
      icon: {
        medium: qualify(Plugins.name('Basic'), iconName('Button')),
        small: qualify(Plugins.name('Basic'), iconName('Button')),
      },
      helpData: {
        description: [
          'This is in support of library demos for Webflow Conf 2022!',
          'We want to allow developers to provide Interactions with their element that is added to the site when the user adds a new instance of their element to the canvas.',
        ],
        tip: 'TBD',
        link: {
          text: 'Learn more about Reusable Element Primitives',
          href: 'https://paper.dropbox.com/doc/Reusable-Element-Primitives--BDuqVzhWpGxWlw7dU6BA4zhvAg-dZKRCSjAOBf6G8TZJ3uQM',
        },
      },
    }),
    IX2InstanceFactoryOnElement: ElementPreset.createSafe({
      factory: EElement({
        id: '37bd5058-c4b7-8c30-6231-80bdfab8e94d',
        type: qualify(Plugins.name('Basic'), Component.name('Link')),
        data: ERecord({
          search: ERecord({
            exclude: EBoolean(false),
          }),
          xattr: EList([]),
          block: EText(''),
          attr: ERecord({}),
          visibility: ERecord({
            conditions: EList([]),
          }),
          button: EBoolean(true),
          eventIds: EList([]),
          link: ELiteral({
            name: qualify(Plugins.name('Basic'), typeName('Link')),
            value: JSON.parse('{"mode":"external","url":"#"}'),
          }),
          styleBlockIds: EList([]),
          children: EList([
            EElement({
              id: '37bd5058-c4b7-8c30-6231-80bdfab8e94e',
              type: qualify(Plugins.name('Basic'), Component.name('String')),
              data: EText('IX2 on Element Presets!'),
            }),
          ]),
        }),
      }),
      interactions: {
        actionLists: [],
        events: [
          {
            id: 'e',
            name: '',
            animationType: 'preset',
            eventTypeId: 'MOUSE_OVER',
            action: {
              id: '',
              actionTypeId: 'SLIDE_EFFECT',
              instant: false,
              // @ts-expect-error - missing properties
              config: {
                actionListId: 'SLIDE_EFFECT',
                autoStopEventId: 'e-2',
              },
            },
            mediaQueries: ['main', 'medium', 'small', 'tiny'],
            target: {
              id: '62fbe671dbb03a4907daaacc|37bd5058-c4b7-8c30-6231-80bdfab8e94d',
              appliesTo: 'ELEMENT',
              styleBlockIds: [],
            },
            targets: [
              {
                id: '62fbe671dbb03a4907daaacc|37bd5058-c4b7-8c30-6231-80bdfab8e94d',
                appliesTo: 'ELEMENT',
                styleBlockIds: [],
              },
            ],
            config: {
              loop: false,
              playInReverse: false,
              scrollOffsetValue: null,
              scrollOffsetUnit: null,
              delay: 0,
              direction: 'LEFT',
              effectIn: true,
            },
            createdOn: 1660940708269,
          },
          {
            id: 'e-2',
            name: '',
            animationType: 'preset',
            eventTypeId: 'MOUSE_OUT',
            action: null,
            mediaQueries: ['main', 'medium', 'small', 'tiny'],
            target: {
              id: '62fbe671dbb03a4907daaacc|37bd5058-c4b7-8c30-6231-80bdfab8e94d',
              appliesTo: 'ELEMENT',
              styleBlockIds: [],
            },
            targets: [
              {
                id: '62fbe671dbb03a4907daaacc|37bd5058-c4b7-8c30-6231-80bdfab8e94d',
                appliesTo: 'ELEMENT',
                styleBlockIds: [],
              },
            ],
            config: {
              loop: false,
              playInReverse: false,
              scrollOffsetValue: null,
              scrollOffsetUnit: null,
              delay: null,
              direction: null,
              effectIn: null,
            },
            createdOn: 1660940708273,
          },
        ],
        interactions: [
          {
            id: 'i',
            interactionTypeId: 'MOUSE_HOVER_INTERACTION',
            eventIds: ['e', 'e-2'],
            target:
              '62fbe671dbb03a4907daaacc|37bd5058-c4b7-8c30-6231-80bdfab8e94d',
            createdOn: 1660940708268,
          },
        ],
      },
      label: 'element ix2',
      icon: {
        medium: qualify(Plugins.name('Basic'), iconName('Button')),
        small: qualify(Plugins.name('Basic'), iconName('Button')),
      },
      helpData: {
        description: [
          'This is in support of library demos for Webflow Conf 2022!',
          'We want to allow developers to provide Interactions with their element that is added to the site when the user adds a new instance of their element to the canvas.',
        ],
        tip: 'TBD',
        link: {
          text: 'Learn more about Reusable Element Primitives',
          href: 'https://paper.dropbox.com/doc/Reusable-Element-Primitives--BDuqVzhWpGxWlw7dU6BA4zhvAg-dZKRCSjAOBf6G8TZJ3uQM',
        },
      },
    }),
  },
});
